export const iconFontAwesomeTextformattingHeading = (
	<i className="fa-solid fa-heading"></i>
);
